/* tslint:disable */
/* eslint-disable */
/**
 * 
 * @export
 * @interface ActivityDetailResponse
 */
export interface ActivityDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof ActivityDetailResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ActivityDetailResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityDetailResponse
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityDetailResponse
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityDetailResponse
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityDetailResponse
     */
    zipCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityDetailResponse
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityDetailResponse
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityDetailResponse
     */
    contact?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityDetailResponse
     */
    registration?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityDetailResponse
     */
    startDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityDetailResponse
     */
    fee?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityDetailResponse
     */
    deadline?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityDetailResponse
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityDetailResponse
     */
    directions?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityDetailResponse
     */
    senior?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityDetailResponse
     */
    startTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityDetailResponse
     */
    endDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityDetailResponse
     */
    endTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityDetailResponse
     */
    fraternalState?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityDetailResponse
     */
    fraternalDivision?: string;
}
/**
 * 
 * @export
 * @interface ActivitySummaryRequest
 */
export interface ActivitySummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryRequest
     */
    fraternalState?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryRequest
     */
    fraternalDivision?: string;
}
/**
 * 
 * @export
 * @interface ActivitySummaryResponse
 */
export interface ActivitySummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof ActivitySummaryResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    city?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ActivitySummaryResponse
     */
    startDate?: Date | null;
}
/**
 * 
 * @export
 * @interface CalculatorRequest
 */
export interface CalculatorRequest {
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    zipCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    age?: string | null;
    /**
     * 
     * @type {Gender}
     * @memberof CalculatorRequest
     */
    gender?: Gender;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    maritalStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    childCount?: string | null;
    /**
     * 
     * @type {Array<CalculatorRequestChild>}
     * @memberof CalculatorRequest
     */
    children?: Array<CalculatorRequestChild> | null;
    /**
     * 
     * @type {HomeStatus}
     * @memberof CalculatorRequest
     */
    homeStatus?: HomeStatus;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    finalExpenses?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    funeralExpenses?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    hospitalBills?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    legalFees?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    doctorBills?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    taxesDue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    otherFinalExpenses?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    mortgage?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    debt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    autoLoans?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    creditCards?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    personalLoans?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    otherDebt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    educationExpenses?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    livingExpensesPerMonth?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    livingExpensesYears?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    livingExpenses?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    currentAssets?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    lifeInsurance?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    retirement?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    stocksBonds?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    cdSavingsCheckings?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    annuities?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    otherAssets?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    total?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    refPage?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    utmParameters?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequest
     */
    custom1?: string | null;
}
/**
 * 
 * @export
 * @interface CalculatorRequestChild
 */
export interface CalculatorRequestChild {
    /**
     * 
     * @type {number}
     * @memberof CalculatorRequestChild
     */
    amount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CalculatorRequestChild
     */
    name?: string | null;
}
/**
 * 
 * @export
 * @interface CalculatorResponse
 */
export interface CalculatorResponse {
    /**
     * 
     * @type {number}
     * @memberof CalculatorResponse
     */
    spiID?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CalculatorResponse
     */
    success?: boolean;
}
/**
 * 
 * @export
 * @interface ChapterEventResponse
 */
export interface ChapterEventResponse {
    /**
     * 
     * @type {number}
     * @memberof ChapterEventResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ChapterEventResponse
     */
    host?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ChapterEventResponse
     */
    chapterNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof ChapterEventResponse
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChapterEventResponse
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChapterEventResponse
     */
    startDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChapterEventResponse
     */
    startTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChapterEventResponse
     */
    endDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChapterEventResponse
     */
    endTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChapterEventResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChapterEventResponse
     */
    detail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChapterEventResponse
     */
    location?: string | null;
}
/**
 * 
 * @export
 * @interface ChapterOfficerResponse
 */
export interface ChapterOfficerResponse {
    /**
     * 
     * @type {string}
     * @memberof ChapterOfficerResponse
     */
    position?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChapterOfficerResponse
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChapterOfficerResponse
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChapterOfficerResponse
     */
    suffixName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChapterOfficerResponse
     */
    phone?: string | null;
}
/**
 * 
 * @export
 * @interface ClaimBeneficiaryRequest
 */
export interface ClaimBeneficiaryRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ClaimBeneficiaryRequest
     */
    isDeceased?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClaimBeneficiaryRequest
     */
    dateOfDeath?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimBeneficiaryRequest
     */
    relationship?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimBeneficiaryRequest
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimBeneficiaryRequest
     */
    middleInitial?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimBeneficiaryRequest
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimBeneficiaryRequest
     */
    suffixName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimBeneficiaryRequest
     */
    address1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimBeneficiaryRequest
     */
    address2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimBeneficiaryRequest
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimBeneficiaryRequest
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimBeneficiaryRequest
     */
    zipCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimBeneficiaryRequest
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimBeneficiaryRequest
     */
    email?: string | null;
}
/**
 * 
 * @export
 * @interface ClaimClaimantRequest
 */
export interface ClaimClaimantRequest {
    /**
     * 
     * @type {string}
     * @memberof ClaimClaimantRequest
     */
    relationship?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimClaimantRequest
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimClaimantRequest
     */
    middleInitial?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimClaimantRequest
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimClaimantRequest
     */
    suffixName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimClaimantRequest
     */
    address1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimClaimantRequest
     */
    address2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimClaimantRequest
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimClaimantRequest
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimClaimantRequest
     */
    zipCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimClaimantRequest
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimClaimantRequest
     */
    phoneType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimClaimantRequest
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimClaimantRequest
     */
    salesId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimClaimantRequest
     */
    deliverCheck?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimClaimantRequest
     */
    deliverForms?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimClaimantRequest
     */
    isBeneficiary?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClaimClaimantRequest
     */
    additionalInformation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimClaimantRequest
     */
    preferredContactMethod?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimClaimantRequest
     */
    utmParameters?: string | null;
    /**
     * 
     * @type {Array<UserJourneyData>}
     * @memberof ClaimClaimantRequest
     */
    userJourney?: Array<UserJourneyData> | null;
}
/**
 * 
 * @export
 * @interface ClaimDeceasedRequest
 */
export interface ClaimDeceasedRequest {
    /**
     * 
     * @type {string}
     * @memberof ClaimDeceasedRequest
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimDeceasedRequest
     */
    middleInitial?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimDeceasedRequest
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimDeceasedRequest
     */
    suffixName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimDeceasedRequest
     */
    dateOfBirth?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimDeceasedRequest
     */
    dateOfDeath?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimDeceasedRequest
     */
    socialSecurityNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimDeceasedRequest
     */
    certificateOne?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimDeceasedRequest
     */
    certificateTwo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimDeceasedRequest
     */
    certificateThree?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimDeceasedRequest
     */
    causeOfDeath?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimDeceasedRequest
     */
    funeralHomeName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimDeceasedRequest
     */
    funeralHomeAddr1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimDeceasedRequest
     */
    funeralHomeAddr2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimDeceasedRequest
     */
    funeralHomeCity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimDeceasedRequest
     */
    funeralHomeState?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimDeceasedRequest
     */
    funeralHomeZip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimDeceasedRequest
     */
    funeralHomePhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimDeceasedRequest
     */
    funeralHomeFax?: string | null;
}
/**
 * 
 * @export
 * @interface ClaimRequest
 */
export interface ClaimRequest {
    /**
     * 
     * @type {ClaimDeceasedRequest}
     * @memberof ClaimRequest
     */
    deceased?: ClaimDeceasedRequest;
    /**
     * 
     * @type {ClaimClaimantRequest}
     * @memberof ClaimRequest
     */
    claimant?: ClaimClaimantRequest;
    /**
     * 
     * @type {ClaimBeneficiaryRequest}
     * @memberof ClaimRequest
     */
    beneficiary?: ClaimBeneficiaryRequest;
}
/**
 * 
 * @export
 * @interface ClaimResponse
 */
export interface ClaimResponse {
    /**
     * 
     * @type {number}
     * @memberof ClaimResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimResponse
     */
    deceasedId?: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimResponse
     */
    beneficiaryId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimResponse
     */
    success?: boolean;
}
/**
 * 
 * @export
 * @interface ContactMeRequest
 */
export interface ContactMeRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactMeRequest
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactMeRequest
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactMeRequest
     */
    zipCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactMeRequest
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactMeRequest
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactMeRequest
     */
    reason?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactMeRequest
     */
    comment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactMeRequest
     */
    sessionId?: string | null;
}
/**
 * 
 * @export
 * @interface EmailSignupRequest
 */
export interface EmailSignupRequest {
    /**
     * 
     * @type {string}
     * @memberof EmailSignupRequest
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailSignupRequest
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailSignupRequest
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailSignupRequest
     */
    mailChimpListType?: string | null;
}
/**
 * 
 * @export
 * @interface FindChapterRequest
 */
export interface FindChapterRequest {
    /**
     * 
     * @type {string}
     * @memberof FindChapterRequest
     */
    zipCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindChapterRequest
     */
    state?: string | null;
}
/**
 * 
 * @export
 * @interface FindChapterResponse
 */
export interface FindChapterResponse {
    /**
     * 
     * @type {number}
     * @memberof FindChapterResponse
     */
    chapterNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof FindChapterResponse
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindChapterResponse
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindChapterResponse
     */
    zipCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindChapterResponse
     */
    readonly siteDir?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindChapterResponse
     */
    ein?: string;
}
/**
 * 
 * @export
 * @interface FindProducerRequest
 */
export interface FindProducerRequest {
    /**
     * 
     * @type {string}
     * @memberof FindProducerRequest
     */
    zipCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProducerRequest
     */
    name?: string | null;
}
/**
 * 
 * @export
 * @interface FindProducerResponse
 */
export interface FindProducerResponse {
    /**
     * 
     * @type {string}
     * @memberof FindProducerResponse
     */
    producerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProducerResponse
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProducerResponse
     */
    alias?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProducerResponse
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProducerResponse
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProducerResponse
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProducerResponse
     */
    zipCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProducerResponse
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProducerResponse
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProducerResponse
     */
    orgCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProducerResponse
     */
    image?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FindProducerResponse
     */
    distance?: number;
    /**
     * 
     * @type {string}
     * @memberof FindProducerResponse
     */
    effectiveDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProducerResponse
     */
    orgType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProducerResponse
     */
    language?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProducerResponse
     */
    siteDirectory?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProducerResponse
     */
    facebookUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProducerResponse
     */
    linkedInUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProducerResponse
     */
    twitterUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProducerResponse
     */
    mobilePhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProducerResponse
     */
    fax?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProducerResponse
     */
    productAvailability?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProducerResponse
     */
    rdName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProducerResponse
     */
    rdEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProducerResponse
     */
    rdPhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProducerResponse
     */
    rdInfo?: string | null;
}
/**
 * 
 * @export
 * @interface FlagRequest
 */
export interface FlagRequest {
    /**
     * 
     * @type {string}
     * @memberof FlagRequest
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlagRequest
     */
    organization?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlagRequest
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlagRequest
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlagRequest
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlagRequest
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlagRequest
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlagRequest
     */
    zipCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlagRequest
     */
    eventType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlagRequest
     */
    eventLocation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlagRequest
     */
    eventDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlagRequest
     */
    eventTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlagRequest
     */
    relationship?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlagRequest
     */
    comments?: string | null;
}
/**
 * 
 * @export
 * @interface FraternalAreaResponse
 */
export interface FraternalAreaResponse {
    /**
     * 
     * @type {string}
     * @memberof FraternalAreaResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FraternalAreaResponse
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FraternalAreaResponse
     */
    division?: string;
    /**
     * 
     * @type {string}
     * @memberof FraternalAreaResponse
     */
    abbreviation?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum Gender {
    Unknown = 'Unknown',
    Male = 'Male',
    Female = 'Female'
}
/**
 * 
 * @export
 * @interface GetAllChaptersResponse
 */
export interface GetAllChaptersResponse {
    /**
     * 
     * @type {number}
     * @memberof GetAllChaptersResponse
     */
    chapterNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof GetAllChaptersResponse
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAllChaptersResponse
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAllChaptersResponse
     */
    zipCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAllChaptersResponse
     */
    ein?: string | null;
    /**
     * 
     * @type {Array<ChapterOfficerResponse>}
     * @memberof GetAllChaptersResponse
     */
    officers?: Array<ChapterOfficerResponse> | null;
}
/**
 * 
 * @export
 * @interface GetChapterEventsRequest
 */
export interface GetChapterEventsRequest {
    /**
     * 
     * @type {number}
     * @memberof GetChapterEventsRequest
     */
    chapterNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof GetChapterEventsRequest
     */
    state?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum HomeStatus {
    Unknown = 'Unknown',
    Rent = 'Rent',
    Own = 'Own'
}
/**
 * 
 * @export
 * @interface LatLongRequest
 */
export interface LatLongRequest {
    /**
     * 
     * @type {number}
     * @memberof LatLongRequest
     */
    latitude?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LatLongRequest
     */
    longitude?: number | null;
}
/**
 * 
 * @export
 * @interface LeadReferrerRequest
 */
export interface LeadReferrerRequest {
    /**
     * 
     * @type {string}
     * @memberof LeadReferrerRequest
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadReferrerRequest
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadReferrerRequest
     */
    addressLine1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadReferrerRequest
     */
    addressLine2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadReferrerRequest
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadReferrerRequest
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadReferrerRequest
     */
    zipCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadReferrerRequest
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadReferrerRequest
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadReferrerRequest
     */
    comments?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LeadReferrerRequest
     */
    skipSubscribe?: boolean;
}
/**
 * 
 * @export
 * @interface LeadReferrerResponse
 */
export interface LeadReferrerResponse {
    /**
     * 
     * @type {number}
     * @memberof LeadReferrerResponse
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LeadReferrerResponse
     */
    saveSuccess?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LeadReferrerResponse
     */
    subscribeSuccess?: boolean;
}
/**
 * 
 * @export
 * @interface LeadRequest
 */
export interface LeadRequest {
    /**
     * 
     * @type {string}
     * @memberof LeadRequest
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadRequest
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadRequest
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadRequest
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadRequest
     */
    zipCode?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof LeadRequest
     */
    interestedIn?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof LeadRequest
     */
    campaignId?: number;
    /**
     * 
     * @type {number}
     * @memberof LeadRequest
     */
    referrerId?: number;
    /**
     * 
     * @type {string}
     * @memberof LeadRequest
     */
    referralRelationship?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadRequest
     */
    custom1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadRequest
     */
    custom2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadRequest
     */
    custom3?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadRequest
     */
    refPage?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadRequest
     */
    sessionId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadRequest
     */
    utmParameters?: string | null;
    /**
     * 
     * @type {Array<UserJourneyData>}
     * @memberof LeadRequest
     */
    userJourney?: Array<UserJourneyData> | null;
    /**
     * 
     * @type {boolean}
     * @memberof LeadRequest
     */
    skipSubscribe?: boolean;
}
/**
 * 
 * @export
 * @interface LeadResponse
 */
export interface LeadResponse {
    /**
     * 
     * @type {number}
     * @memberof LeadResponse
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LeadResponse
     */
    success?: boolean;
}
/**
 * 
 * @export
 * @interface NcfStateStatsResponse
 */
export interface NcfStateStatsResponse {
    /**
     * 
     * @type {string}
     * @memberof NcfStateStatsResponse
     */
    abbreviation?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NcfStateStatsResponse
     */
    poundsFoodDonated?: number;
    /**
     * 
     * @type {number}
     * @memberof NcfStateStatsResponse
     */
    moneyDonated?: number;
}
/**
 * 
 * @export
 * @interface NoSaleStateRequest
 */
export interface NoSaleStateRequest {
    /**
     * 
     * @type {string}
     * @memberof NoSaleStateRequest
     */
    zipCode?: string | null;
}
/**
 * 
 * @export
 * @interface NoSaleStateResponse
 */
export interface NoSaleStateResponse {
    /**
     * 
     * @type {string}
     * @memberof NoSaleStateResponse
     */
    zipCode?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NoSaleStateResponse
     */
    isNoSaleState?: boolean;
}
/**
 * 
 * @export
 * @interface ProblemDetails
 */
export interface ProblemDetails {
    [key: string]: any | any;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    title?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProblemDetails
     */
    status?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    detail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    instance?: string | null;
}
/**
 * 
 * @export
 * @interface RecruitingLeadRequest
 */
export interface RecruitingLeadRequest {
    /**
     * 
     * @type {string}
     * @memberof RecruitingLeadRequest
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecruitingLeadRequest
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecruitingLeadRequest
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecruitingLeadRequest
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecruitingLeadRequest
     */
    zipCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecruitingLeadRequest
     */
    sessionId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecruitingLeadRequest
     */
    campaignRef?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecruitingLeadRequest
     */
    utmParameters?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecruitingLeadRequest
     */
    contactMethod?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RecruitingLeadRequest
     */
    careerExperience?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RecruitingLeadRequest
     */
    lookingFor?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RecruitingLeadRequest
     */
    strengths?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface RecruitingLeadResponse
 */
export interface RecruitingLeadResponse {
    /**
     * 
     * @type {number}
     * @memberof RecruitingLeadResponse
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RecruitingLeadResponse
     */
    success?: boolean;
}
/**
 * 
 * @export
 * @interface ScholarshipWinnerRequest
 */
export interface ScholarshipWinnerRequest {
    /**
     * 
     * @type {number}
     * @memberof ScholarshipWinnerRequest
     */
    year?: number;
    /**
     * 
     * @type {string}
     * @memberof ScholarshipWinnerRequest
     */
    state?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ScholarshipWinnerRequest
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof ScholarshipWinnerRequest
     */
    pageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof ScholarshipWinnerRequest
     */
    pageSize?: number;
}
/**
 * 
 * @export
 * @interface ScholarshipWinnerResponse
 */
export interface ScholarshipWinnerResponse {
    /**
     * 
     * @type {string}
     * @memberof ScholarshipWinnerResponse
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScholarshipWinnerResponse
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScholarshipWinnerResponse
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScholarshipWinnerResponse
     */
    amount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScholarshipWinnerResponse
     */
    year?: string | null;
}
/**
 * 
 * @export
 * @interface ScholarshipWinnerResponsePagedResults
 */
export interface ScholarshipWinnerResponsePagedResults {
    /**
     * 
     * @type {number}
     * @memberof ScholarshipWinnerResponsePagedResults
     */
    pageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof ScholarshipWinnerResponsePagedResults
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof ScholarshipWinnerResponsePagedResults
     */
    totalNumberOfPages?: number;
    /**
     * 
     * @type {number}
     * @memberof ScholarshipWinnerResponsePagedResults
     */
    totalNumberOfRecords?: number;
    /**
     * 
     * @type {Array<ScholarshipWinnerResponse>}
     * @memberof ScholarshipWinnerResponsePagedResults
     */
    records?: Array<ScholarshipWinnerResponse> | null;
}
/**
 * 
 * @export
 * @interface SingleActivityRequest
 */
export interface SingleActivityRequest {
    /**
     * 
     * @type {number}
     * @memberof SingleActivityRequest
     */
    activityId?: number;
}
/**
 * 
 * @export
 * @interface SingleProducerRequest
 */
export interface SingleProducerRequest {
    /**
     * 
     * @type {string}
     * @memberof SingleProducerRequest
     */
    producerId?: string | null;
}
/**
 * 
 * @export
 * @interface UserJourneyData
 */
export interface UserJourneyData {
    /**
     * 
     * @type {string}
     * @memberof UserJourneyData
     */
    page?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserJourneyData
     */
    timestamp?: string | null;
}
